import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "popup__message" }

import {ref, onMounted} from 'vue';
import ConfirmationPopup from "@/ts/Popup/ConfirmationPopup";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmationPopup',
  setup(__props) {

const show = ref<Boolean>(false);
const popupRef = ref<HTMLElement | null>(null);
const message = ref<string>('');
const instance = ConfirmationPopup.getInstance();
const closing = ref(false)
const handleConfirm = () => {
  instance.confirm()
};
const easyClosing = () => {
  closing.value = true

  setTimeout(() => {
    closing.value = false
  }, 600)
}
const handleCancel = () => {
  instance.hide();
};
onMounted(() => {
  instance.init(show, popupRef.value!, message);
  instance.addHideCallback(easyClosing);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["popup-wrapper", {show: show.value, closing: closing.value}])
  }, [
    _createElementVNode("div", {
      class: "popup",
      ref_key: "popupRef",
      ref: popupRef
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(message.value), 1),
      _createElementVNode("div", { class: "popup__actions" }, [
        _createElementVNode("div", {
          class: "popup__button",
          onClick: handleCancel
        }, "Нет"),
        _createElementVNode("div", {
          class: "popup__button error",
          onClick: handleConfirm
        }, "Да")
      ])
    ], 512)
  ], 2))
}
}

})